import React, { useEffect, useState } from 'react';

interface PolicySection {
  title: string;
  content: string[];
}

const PrivacyPolicy: React.FC = () => {
  const [policyData, setPolicyData] = useState<PolicySection[]>([]);

  // Simulated API call
  useEffect(() => {
    const fetchPolicy = async () => {
      // Later, replace this with your API call
      const data: PolicySection[] = [
        {
          title: 'Privacy Policy',
          content: [
            'By accessing or using UGEXAMPLE, you agree to be bound by these Terms of Service. These terms govern your use of our website, mobile application, and related services. You agree to use the platform responsibly and for lawful purposes only.',
            'All content available on this platform—including text, data, reports, analytics, and software—is the exclusive property of UGEXAMPLE and protected by applicable intellectual property laws. You may not copy or reproduce any part without permission.',
            'The platform may display data related to energy or system analytics. While we strive for accuracy, UGEXAMPLE is not liable for any losses due to reliance on provided data.',
            'To access certain features, you may need to register and maintain a user account. You are responsible for keeping your credentials secure and notifying us of any unauthorized access.',
            'We reserve the right to update these Terms of Service without prior notice. Continued use indicates acceptance of updated terms.',
            'For any questions or feedback, contact us at 📧 support@ugexample.com.',
          ],
        },
      ];
      setPolicyData(data);
    };

    fetchPolicy();
  }, []);

  return (
    <div className="bg-white text-gray-700 px-4 mx-auto leading-relaxed">
      {policyData.map((section, index) => (
        <div key={index}>
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">{section.title}</h1>
          {section.content.map((paragraph, i) => (
            <p key={i} className="mb-5 text-[15px] text-gray-500">
              {paragraph}
            </p>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
